import { IconSearch } from "@tabler/icons-react";
import { useAtom } from "jotai";
import { searchOpenAtom } from "@/stores/search-atom";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";

interface Props {
  className?: React.HTMLAttributes<HTMLElement>["className"];
  type?: React.HTMLInputTypeAttribute;
  placeholder?: string;
}

export const Search: React.FC<Props> = ({
  className = "",
  placeholder = "Search",
}: Readonly<Props>) => {
  const [, setOpen] = useAtom(searchOpenAtom);

  return (
    <Button
      variant="outline"
      className={cn(
        "bg-muted/25 hover:bg-muted/50 text-muted-foreground relative h-8 w-full flex-1 justify-start rounded-md text-sm font-normal shadow-none sm:pr-12 md:w-40 md:flex-none lg:w-56 xl:w-64",
        className,
      )}
      onClick={() => setOpen(true)}
    >
      <IconSearch
        aria-hidden="true"
        className="absolute left-1.5 top-1/2 -translate-y-1/2"
      />
      <span className="ml-3">{placeholder}</span>
      <kbd className="bg-muted pointer-events-none absolute right-[0.3rem] top-[0.3rem] hidden h-5 select-none items-center gap-1 rounded border px-1.5 font-mono text-[10px] font-medium opacity-100 sm:flex">
        <span className="text-xs">⌘</span>K
      </kbd>
    </Button>
  );
};
